import React from 'react'
import SelectCustom from '../../atoms/select/SelectCustom'
import InputCustom from '../../atoms/input/InputCustom'
import { Grid } from '@mui/material'
import styles from '../index.module.scss'

export const Transportation = () => {
	return (
		<>
			<div>
				<h3 className={styles.Title}>Transportation Survey</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="companyContactName"
								className={styles.label}
							>
								Company contact name
							</label>
							<InputCustom
								id="companyContactName"
								name="companyContactName"
								placeholder="Enter Company contact name"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="companyContactNumber"
								className={styles.label}
							>
								Company contact number
							</label>
							<InputCustom
								id="companyContactNumber"
								name="companyContactNumber"
								placeholder="Enter Company Contact Number"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="vehicleTypes"
								className={styles.label}
							>
								Vehicle types
							</label>
							<InputCustom
								id="vehicleTypes"
								name="vehicleTypes"
								placeholder="e.g., limo, shuttle, classic car, etc."
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="numberOfVehicles"
								className={styles.label}
							>
								Number of vehicles:
							</label>
							<InputCustom
								id="numberOfVehicles"
								name="numberOfVehicles"
								placeholder="Enter number of vehicles"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="totalPassengersPerTrip"
								className={styles.label}
							>
								Total passengers per trip
							</label>
							<InputCustom
								id="totalPassengersPerTrip"
								name="totalPassengersPerTrip"
								placeholder="Enter"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Route & Schedule</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="pickupLocation"
								className={styles.label}
							>
								Pickup location(s)
							</label>
							<InputCustom
								id="pickupLocation"
								name="pickupLocation"
								placeholder="Enter pickup location(s)"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="dropOffLocation"
								className={styles.label}
							>
								Drop-off location(s)
							</label>
							<InputCustom
								id="dropOffLocation"
								name="dropOffLocation"
								placeholder="Enter drop-off location(s)"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="pickupTimes"
								className={styles.label}
							>
								Pickup times
							</label>
							<InputCustom
								id="pickupTimes"
								name="pickupTimes"
								placeholder="Enter pickup times"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="returnTrips"
								className={styles.label}
							>
								Return trips?
							</label>
							<SelectCustom
								id="returnTrips"
								name="returnTrips"
								label="Select"
								options={[
									{ value: 'yes', label: 'Yes' },
									{ value: 'no', label: 'No' },
								]}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="returnTrips"
								className={styles.label}
							>
								Duration of travel per route
							</label>
							<InputCustom
								id="returnTrips"
								name="returnTrips"
								placeholder="Enter return trips"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="returnTrips"
								className={styles.label}
							>
								Contingency time built in?
							</label>
							<InputCustom
								id="returnTrips"
								name="returnTrips"
								placeholder="Enter"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Dependencies</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="returnTrips"
								className={styles.label}
							>
								Parking/loading zones required?
							</label>
							<InputCustom
								id="returnTrips"
								name="returnTrips"
								placeholder="Enter venue setup window"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="returnTrips"
								className={styles.label}
							>
								Coordination with planner or venue security?
							</label>
							<SelectCustom
								id="returnTrips"
								name="returnTrips"
								label="Select"
								options={[
									{ value: 'self', label: 'self' },
									{ value: 'venue', label: 'venue' },
								]}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Other Questions</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="rainContingency"
								className={styles.label}
							>
								Rain contingency or setup change needed?
							</label>
							<InputCustom
								id="rainContingency"
								name="rainContingency"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupDuration"
								className={styles.label}
							>
								Setup / teardown duration
							</label>
							<InputCustom
								id="setupDuration"
								name="setupDuration"
								placeholder="Enter details"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="specialEquipment"
								className={styles.label}
							>
								Special equipment or space needs?
							</label>
							<InputCustom
								id="specialEquipment"
								name="specialEquipment"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="contactForDayOfEmergencies"
								className={styles.label}
							>
								Contact for day-of emergencies
							</label>
							<InputCustom
								id="contactForDayOfEmergencies"
								name="contactForDayOfEmergencies"
								placeholder="Enter contact for day-of emergencies"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}
